import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import { ConfigurationManagerService } from './configuration-manager.service';
import { ChangePasswordRequest, ChangePinRequest } from '../models/Common';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private _verifiedPin: string | undefined;
  constructor(private http: HttpClient) { }

  getUserProfile(): Observable<any> {
    const userId = localStorage.getItem('PAA_USER_ID');
    const url = `${ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.Profile}/${userId}/profile/`;
    return this.http.get<any>(url);
  }
  getLoginProfile(id:string): Observable<any> {
    const url = `${ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.Profile}/${id}/profile/`;
    return this.http.get<any>(url).pipe(
      tap((profile: any) => {
        if (profile?.name) {
          localStorage.setItem('PAA_Name', profile.name);
        }
        if (profile?.UserOrganizations?.[0]?.Organization?.id) {
          const orgId = String(profile.UserOrganizations[0].Organization.id);
          localStorage.setItem('PAA_org', orgId);
          window.dispatchEvent(new CustomEvent('orgUpdated', { detail: orgId }));
        }
      })
    );
  }

  getUserRoles(): Observable<any> {
    const url = `${ConfigurationManagerService.settings.TezAddPapiBaseUrl + ConfigurationManagerService.settings.UserRole}`;
    return this.http.get<any>(url);
  }
  
  changePassword(oldPassword: string, newPassword: string): Observable<void> {
    const payload: ChangePasswordRequest = {
      oldPassword,
      password: newPassword
    };

    const url = ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.ChangePassword;

    return this.http.post<void>(url, payload);
  }

  changePin(oldPin: string, newPin: string): Observable<any> {
    const payload: ChangePinRequest = {
      oldPin,
      pin: newPin
    };

    const url = ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.ChangePin;

    return this.http.post<any>(url, payload);
  }

  forgotPin(email: string): Observable<void> {
    const url = ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.ForgotPin;
    return this.http.post<void>(url, { email });
  }

  resetPin(email: string, verificationCode: string, newPin: string , confirmPin: string): Observable<void> {
    const url = ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.ResetPin;
    return this.http.post<void>(url, {userEmail: email, verificationCode, pin: newPin , verifyPin : confirmPin});
  }

  verifyPin(pin: string): Observable<{ validPin: boolean }> {
    const url = ConfigurationManagerService.settings.BaseURL + ConfigurationManagerService.settings.VerifyPin + pin;
    return this.http.get<any>(url).pipe(
      map((response: { valid: boolean; }) => {
        if (response.valid) {
          this._verifiedPin = pin;
        }
        return { validPin: response?.valid ?? false };
      })
    );
  }
}